// services/env.service.js
function safeAuth() {
  try {
    let token = null
    if (sessionStorage.getItem('auth-token')) {
        token = sessionStorage.getItem('auth-token')
    } else if (localStorage.getItem('auth-token')) {
        token = localStorage.getItem('auth-token')
    }
    return token ? token : null;
  } catch {
    return null;
  }
}

let baseUrl;
let frontUrl;

if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    baseUrl = 'http://127.0.0.1:8044';
    // baseUrl = 'http://192.168.1.144:8000';
} else {
    baseUrl = 'https://api.termoflow.fr';
}

if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    frontUrl = 'http://127.0.0.1:8144';
    // frontUrl = 'http://192.168.1.144:8000';
} else {
    frontUrl = 'https://termoflow.fr';
}

const mapboxKey = 'pk.eyJ1IjoidmljdG9yYW53IiwiYSI6ImNrajhuam1iOTZ1dnQydnFqbzRldDJrdW8ifQ.VkIKVhh5_Pcp7PxqQ-GCCg'

const stripeKey = 'pk_test_51TI4H6385z8EioJuKE1qAR3eizwf74t51VYBBVPo1NNh0IiIuM8jJtQFyyn05y7ORF3lHUgxnJaoYupZUdTliNtK00Mj1pUik4'

const env = Object.freeze({
  baseUrl,
  frontUrl,
  mapboxKey,
  stripeKey,
  get apiUrl() {
    return `${baseUrl}/api`;
  },
  get authToken() {
    return safeAuth() ?? null;
  }
});

export default env;
